<template>
<v-flex xs12>
    <v-toolbar>
        <v-toolbar-title class="headline mb-0 hidden-sm-and-up">Import</v-toolbar-title>
        <v-toolbar-title class="headline mb-0 hidden-xs-only">Import Sprays</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
            <v-btn fab small dark color="primary" @click.native="addUploadDocument" :disabled="IsImporting">
                <v-icon dark>add</v-icon>
            </v-btn>
            <v-btn fab small dark color="green" @click.native="onSaveButtonClicked" :disabled="IsImporting">
                <v-icon dark>save</v-icon>
            </v-btn>
            <v-btn fab small dark color="red" @click.native="onCancelButtonClicked" :disabled="IsImporting">
                <v-icon dark>cancel</v-icon>
            </v-btn>
        </v-toolbar-items>
    </v-toolbar>

    <!-- List for upload files field -->
    <div class="FileUploadContainer">
        <template v-for="(file, index) in this.files">
            <div v-bind:item="file" v-bind:index="index" v-bind:key="index">
                <v-layout row>
                    <v-text-field @click.native='pickFile(index)' v-model='file.name' readonly label="Import Sprays"></v-text-field>
                    <v-btn color="primary" fab small dark @click.native="clearIconClicked(index)" v-if="file.name">
                        <v-icon>clear</v-icon>
                    </v-btn>
                    <input :id="'upload-' + index" type="file" class="uploadInput" ref="input" :accept="AllowedFileExtensions" @change="onFilePicked" />
            </v-layout>
                    <v-alert :value="!file.valid" color="error" icon="warning" outline>
                        Uploaded files must be less than {{MaxFileSizeMB}}MB. Valid file types include {{AllowedFileExtensions}}.
                    </v-alert>
            </div>
        </template>
    </div>
</v-flex>
</template>

<script>
export default {
    data() {
        return {
            files: []
        }
    },
    props: {
        MaxFileSizeMB: {
            type: Number,
            required: true,
            default: 1
        },
        AllowedFileExtensions: {
            type: String,
            required: true,
            default: '.csv'
        },
        MultipleFilesImport : {
            type: Boolean,
            required: true,
            default: false
        },
        IsImporting: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    computed: {
        AllowedExtensionsArray() {
            if (this.AllowedFileExtensions) {
                //remove spaces and periods
                //make it all lower case
                //split on comma to return array of strings
                let l_cleanString = this.AllowedFileExtensions.replace(/\s/g, '').replace(/\./g, '').toLowerCase();
                return l_cleanString.split(",");
            } else {
                return [];
            }
        }
    },
    methods: {
        addUploadDocument() {
            if(this.MultipleFilesImport || this.files.length == 0) {
                this.files.push({
                    name: "",
                    data: "",
                    valid: true
                });
            }
        },
        pickFile(index) {
            this.$refs.input[index].click()
        },
        clearIconClicked(index) {
             if (this.files[index].name) {
                this.files.splice(index, 1);
            } else {
                this.$refs.input[index].click()
            }
        },
        onFilePicked(e) {
            var self = this;
            const readFiles = e.target.files;
            var id = e.target.id ? e.target.id.replace("upload-", "") : 0

            if (readFiles[0] !== undefined) {
                if ((readFiles[0].size / 1024 / 1024) >= self.MaxFileSizeMB) {
                    //file is larger than allowed
                    self.files[id].valid = false;
                    return;
                } else {
                    //file is within size limits
                    //check extensions
                    let l_fileName = readFiles[0].name;
                    if (l_fileName.includes(".")) {
                        //file name contains a period
                        let l_stringParts = l_fileName.split(".");
                        if (l_stringParts && l_stringParts.length > 0) {
                            let l_extension = l_stringParts[l_stringParts.length - 1].trim().toLowerCase();
                            //check that extension is in list of allowed types
                            if (self.AllowedExtensionsArray.includes(l_extension)) {
                                //file extension is allowed
                                self.files[id].valid = true;
                            } else {
                                //extension not in allowed list
                                self.files[id].valid = false;
                                return;
                            }
                        } else {
                            //error
                            self.files[id].valid = false;
                            return;
                        }
                    } else {
                        //no extension
                        self.files[id].valid = false;
                        return;
                    }
                }

                self.files[id].name = readFiles[0].name;
                var re = /(?:\.([^.]+))?$/;
                self.files[id].type = re.exec(readFiles[0].name ? readFiles[0].name : "")[1];
                self.files[id].size = readFiles[0].size;
                if (self.files[id].name <= 0) {
                    return;
                }
                self.files[id].data = readFiles[0]
            } else {
                self.files[id].name = "";
                self.files[id].data = "";
            }
        },
        onSaveButtonClicked() {
            if(this.files.length > 0 && this.files[0].data) {
                this.$emit('Save', this.files[0]);
                 this.files = [];
            }
        },
        onCancelButtonClicked() {
            this.files = [];
            this.$emit('Close');
        }
    }
}
</script>

<style scoped>
div.FileUploadContainer {
    margin-top: 15px;
    margin-left: 10px;
}

.uploadInput {
 display: none;
}
</style>
